import * as React from "react";
import animationData from "../../assets/animation/mmc_loader.json";
import AnimationComp from "../animation-comp/AnimationComp.component";

export default function ProgressBar() {
  return (
    <div className="cm-progress-bar d-flex justify-content-center align-items-center p-5">
      <AnimationComp animationData={animationData} width={100} height={100} />
    </div>
  );
}
